
import { Component, Vue } from 'vue-property-decorator'
import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'

@Component({
  components: {
    BacLoggedInHeader
  }
})
export default class RallySearch extends Vue {

}
